import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BarnyardIcon } from 'barnyard/icons';
import { hasAlertFullPermissions } from '~/app/corporate/core/selectors';


class AlertItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_expanded: false
    };

    _.bindAll(this, 'onDeleteToggle', 'onIsFlaggedToggle');
  }

  onDeleteToggle() {
    const { onIsDeletedChange, alert } = this.props;

    onIsDeletedChange(alert.id, !alert.is_deleted);
  }

  onIsFlaggedToggle() {
    const { onIsFlaggedChange, alert } = this.props;

    onIsFlaggedChange(alert.id, !alert.is_flagged);
  }

  render() {
    const {
      alert, icon, date, title, content
    } = this.props;
    const { is_expanded } = this.state;

    // Alerts pending deletion get a deleted display. They will not appear on reload
    if (alert.is_deleted) {
      return (
        <div className='DiscussCard u-padding5 u-center'>
          This alert has been dismissed. {' '}
          <a
            className='u-hoverable'
            onClick={this.onDeleteToggle}
          >
            Undo
          </a>
        </div>
      );
    }

    return (
      <div className='DiscussCard'>
        <div className='DiscussCard__reason'>
          {React.isValidElement(icon)
            ? icon
            : <i className={`DiscussCard__replyIcon fa fa-${icon}`} />
          }
          {alert.corporate_rule.display}
          <span className='Discuss__dividerDot'>&bull;</span>
          <span className='Discuss__date'>
            {date}
          </span>
        </div>
        {this.props.hasAlertPermissions && (
          <div className='DiscussCard__menu'>
            <span
              onClick={this.onIsFlaggedToggle}
              className='rDashboardAlert__icon u-marginRight10'
            >
              {alert.is_flagged
                ? <BarnyardIcon icon={['fas', 'flag']} className='color-primary' />
                : <BarnyardIcon icon={['fas', 'flag']} />
              }
            </span>
            <span
              onClick={this.onDeleteToggle}
              className='rDashboardAlert__icon'
            >
              <BarnyardIcon icon={['fas', 'window-close']} />
            </span>
          </div>)}
        <div className='DiscussCard__content'>
          <div className='DiscussCard__comment DiscussCard__comment--child'>
            <div className='DiscussCard__commentBody'>
              {title}
              {content && (
                <a
                  className='DiscussCard__viewLink u-hoverable'
                  onClick={() => this.setState({ is_expanded: !is_expanded })}
                >
                  {!is_expanded
                    ? <span>Show Details <i className='fa fa-angle-down' /></span>
                    : <span>Hide Details <i className='fa fa-angle-up' /></span>
                  }
                </a>)}
            </div>
          </div>
        </div>
        {is_expanded
          ? <div className='DiscussCard__details'>
            {this.props.content}
          </div>
          : null}
      </div>
    );
  }
}

AlertItem.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  date: PropTypes.string,
  title: PropTypes.node,
  content: PropTypes.node,
  hasAlertPermissions: PropTypes.bool
};

AlertItem.defaultProps = {
  icon: 'exclamation-triangle'
};

const mapStateToProps = state => ({
  hasAlertPermissions: hasAlertFullPermissions(state)
});

export default connect(mapStateToProps)(AlertItem);
